
<div class="wrapper mb-2">
    <div class="row title-container align-items-center mb-4" style="padding: 10px;">
        <img src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Novos Produtos</span>
    </div>
    <mat-drawer-container class="drawer-container" (backdropClick)="close()" hasBackdrop="true">
        <mat-drawer #drawer mode="over" position="end" (keydown.escape)="close()" class="drawer">
            <div class="container mb-5 mt-2 dcontainer">
                <h6 class="clean-modal-title text-center mb-2" style="font-size: 20px;">
                    Deseja distribuir o Bankei {{termoUso != undefined ? termoUso.produto.descricao : 'esse incentivo'}} <br> para seus favorecidos?
                </h6>
                <h6 class="text-center mb-2"> Configure e faça a adesão agora!</h6>
                <form [formGroup]="newContratoForm" (ngSubmit)="onSubmit(newContratoForm.value)" #contratoForm="ngForm">
                    <div class="form-group">
                        <label for="valorPadrao" class="clean-modal-section-title ">Valor Padrão <b style="color:red">*</b> </label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorPadrao" type="number" id="valorPadrao" value="valorPadrao" [ngClass]="{'is-invalid':inValorPadraoInvalid}" class="input-border-botton form-control" min="1" #valorPadrao  required/>
                        </div>
                    </div>
                    <div *ngIf="form.valorPadrao.invalid && (form.valorPadrao.dirty || form.valorPadrao.touched)"
                        class="invalid-feedback">
                        <div *ngIf="form.valorPadrao.errors.required">
                            Você deve definir um valor padrão!
                        </div>
                        <div *ngIf="form.valorPadrao.errors.min">
                            O valor padrão deve ser maior que zero!
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="inValorPadraoInvalid">
                        {{messageValorPadrao}}
                    </span>
                    <div class="form-group">
                        <label for="periodoPadrao" class="clean-modal-section-title ">Período Padrão <b style="color:red">*</b> </label>
                        <select *ngIf="!hasStandardPeriod" formControlName="cartaoPeriodoPadraoId" #periodoPadrao id="periodoPadrao" class="form-control" >
                            <option *ngFor="let item of cartaoPeriodosPadroes" [value]="item.ITEM_ID">{{item.ITEM_TEXT}}
                            </option>
                        </select>
                        <select *ngIf="hasStandardPeriod" formControlName="cartaoPeriodoPadraoId" #periodoPadrao id="periodoPadrao" class="form-control" >
                            <option *ngFor="let item of cartaoPeriodoPadrao" [value]="item.id">{{item.descricao}}
                            </option>
                        </select>
                    </div>
                    <div *ngIf="form.cartaoPeriodoPadraoId.invalid && (form.cartaoPeriodoPadraoId.dirty || form.cartaoPeriodoPadraoId.touched)"
                        class="invalid-feedback">
                        <div *ngIf="form.cartaoPeriodoPadraoId.errors.required">
                            Você deve definir um período padrão!
                        </div>
                    </div>

                    <div class="form-group">
                        <div class="clean-modal-section-title ">É editável</div>
                        <div class="form-group">
                            <input formControlName="ehEditavel" #ehEditavel id="ehEditavel" class="rdButton mx-2" type="checkbox" checked="true"/>
                            <label for="ehEditavel" class="form-check-label">
                            </label>
                        </div>
                    </div>

                    <div class="form-group">
                        <label for="valorMaximoBaneficio" class="clean-modal-section-title ">Valor Máximo do Produto</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorMaximoBeneficio" type="number" id="valorMaximoBaneficio" value="valorMaximoBaneficio" [ngClass]="{'is-invalid':inValorMaximoInvalid}" class="form-control" #valorMaximoBaneficio/>
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="inValorMaximoInvalid">
                        {{messageValorMaximo}}
                    </span>

                    <div class="form-group" *ngIf="permitirValorIncremento">
                        <label for="valorIncremento" class="clean-modal-section-title ">Valor de Incremento</label>
                        <div class="input-group">
                            <div class="input-group-prepend">
                                <span class="input-group-text">R$</span>
                            </div>
                            <input formControlName="valorIncremento" type="number" id="valorIncremento"  value="valorIncremento" [ngClass]="{'is-invalid':inValorIncrementoInvalid}" class="form-control" #valorIncremento/>
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="inValorIncrementoInvalid && permitirValorIncremento">
                        {{messageValorIncremento}}
                    </span>

                    <div class="form-group mb-2" *ngIf="!acceptedTermo">
                        <div class="form-group">
                            <input formControlName="termoUsoAceito" #termoUsoUrl id="termoUsoUrl" class="rdButton mx-2" type="checkbox" (change)="readTermo($event)"/>
                            <label for="termoUsoUrl" class="form-check-label">
                                Eu aceito os termos de uso
                            </label>
                        </div>
                    </div>
                    <span class="invalid-feedback" *ngIf="isTermoInvalid">
                        {{messageTermo}}
                    </span>

                    <div class="col-12 mt-3">
                        <div class="col-md-12 col-sm-12 row justify-content-center pr-0">
                            <button class="custom-filter-button button-color-red w-75" type="button" (click)="drawer.toggle();">Cancelar</button>
                        </div>
                        <div class="col-md-12 col-sm-12 row justify-content-center pr-0">
                            <button class="custom-filter-button button-color-just w-75 mt-2" type="submit">Aderir</button>
                        </div>
                    </div>
                </form>
                <div class="m-3">
                    <p class="text-justify">Nesta tela, informe o valor padrão e a periodicidade que deseja distribuir aos seus favorecidos neste produto. Fique tranquilo,  são apenas valores usados como referência, você poderá depois determinar o valor e periodicidade para cada favorecido que incluir na plataforma.
                        <br>
                        Informe se o valor definido poderá ser editável ou não, assim, você terá maior tranquilidade ao editar posteriormente os valores determinados aos favorecidos.
                        <br>
                        <span *ngIf="permitirValorIncremento">
                            Opcionalmente, você ainda poderá determinar um valor máximo que um favorecido poderá ter em sua configuração e poderá também determinar um valor de incremento, valor este que será utilizado no momento da distribuição de créditos, respeitando o valor máximo para distribuição caso exista.
                        </span>
                    </p>
                </div>
            </div>
        </mat-drawer>
        <mat-drawer-content>

            <!--
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12 text-left form-title
                        mb-5">
                        <span class="form-title">
                            SELECIONE OS BENEFICIOS QUE DESEJA CONTRATAR PARA A SUA
                            EMPRESA
                        </span>

                    </div>
                </div>
            </div> -->



            <div class="header-escolha row mt-3">
                <div class="header-margin row">
                    <div class="header-separar row">
                        <div *ngFor="let item of produtoCategoria">
                            <div class="header-item">
                                <input value="{{item.id}}" type="radio" name="tipo-beneficio"
                                    id="{{item.id}}" (change)="changeCategory($event)" [checked]="item.id == 1 ? true : '' ">
                                <label for="{{item.id}}" class="form-check-label font-weight-normal header-item-descricao">{{item.categoryAssignorLabel}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-box container-fluid">
                <div class="container-fluid pt-5 pb-2 pl-4">
                    <div class="row">
                        <div class="col-md-12 col-sm-12">
                            <div class="row h-100">
                                <input class="list-header-search-input" type="search" placeholder="Pesquise aqui..." [(ngModel)]="filtroPesquisa" (input)="searchFilter()" />
                                <div class="list-show-item ml-5">Mostrar:
                                    <select [(ngModel)]="showItem">
                                        <option [ngValue]="10" value="10"d>10</option>
                                        <option [ngValue]="25" value="25" selected>25</option>
                                        <option [ngValue]="50" value="50">50</option>
                                        <option [ngValue]=100 value="100">100</option>
                                    </select>
                                </div>
                                <div class="list-pagination ml-2">
                                    <pagination-controls (pageChange)="currentPage=$event" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12" *ngIf="isEmpty" style="min-height: 5vh;">
                        <p class="text-center form-title my-5">{{messageErro}}</p>
                    </div>
                    <div class="custom-col-produto" *ngFor="let listProdutos of
                        produtoElegibilidadeList">
                        <div class="p-2 m-2" (click)="showTermo(termo, listProdutos.produto.produtoGuid,
                            listProdutos.produtoElegibilidadeId, listProdutos)">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="card-img clickable">
                                        <app-svg-card [color]="listProdutos.produto.color" [icon]="listProdutos.produto.iconeProduto" [name]="listProdutos.produto.descricao"></app-svg-card>
                                    </div>
                                    <!--img [src]="'./assets/icons/produtos/icon-produtos/'+
                                        listProdutos.produto.produtoGuid +'.svg'"
                                        onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';" class="card-img clickable"
                                        alt="{{listProdutos.produto.descricao}}" /-->
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <p class="card-title">{{listProdutos.produto.descricao}}</p>
                                    <p class="card-subtitle">{{listProdutos.produto.descricaoImportante}}</p>
                                    <p class="card-subtitle mt-2" *ngIf="listProdutos.taxaPedido > 0 && listProdutos.ehPorcentagem">Taxa administrativa: {{listProdutos.taxaPedido}}%</p>
                                    <p class="card-subtitle mt-2" *ngIf="listProdutos.taxaPedido > 0 && !listProdutos.ehPorcentagem">Taxa administrativa: {{listProdutos.taxaPedido | currency: 'BRL' : true}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-drawer-content>
    </mat-drawer-container>
</div>


<ng-template #termo let-modal>
    <div *ngIf="termoUso">
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="modal-title clean-modal-title text-center">
                    {{termoUso.produto.descricao}}
                </h5>
            </div>
        </div>
        <div class="col-12 clean-modal-content">
            <ng-container *ngIf="!isFlex">
                <p class="clean-modal-subtitle text-center" style="font-size: 1.375rem; color: #555;">Deseja começar a distribuir
                {{termoUso.produto.descricao}} para seus
                favorecidos? <br> {{termoUso.url ? 'Leia o termo e faça a adesão agora!' : 'Faça sua adesão agora!'}} </p>
                <iframe *ngIf="termoUso.url" class="custom-termo" [src]="termoUso.url | safe"></iframe>
            </ng-container>
            <ng-container *ngIf="isFlex">
                <p class="clean-modal-subtitle text-center" style="font-size: 1.375rem; color: #555;">
                    Deseja começar a distribuir {{termoUso.produto.descricao}} para seus favorecidos? <br> O produto {{termoUso.produto.descricao}} requer que no mínimo <b>2</b> produtos tradicionais sejam aderidos e assim você possa distribuí-lo. <br> {{termoUso.url ? 'Leia o termo e faça a adesão agora!' : 'Faça sua adesão agora!'}} </p>
                    <iframe *ngIf="termoUso.url" class="custom-termo" [src]="termoUso.url | safe"></iframe>
            </ng-container>
        </div>
        <div class="clean-modal-footer col-12 mb-4">
            <button *ngIf="isFlex || isLog" class="custom-filter-button button-color-just" type="button" (click)="isAllowed();modal.dismiss('Close click')">{{ (termoUso.url) ? 'Aceito' : 'Aderir' }}</button>
            <button *ngIf="!isFlex && !isLog" class="custom-filter-button button-color-just" type="button" (click)="aceito();modal.dismiss('Close click')">{{ (termoUso.url) ? 'Aceito' : 'Aderir' }}</button>
        </div>
    </div>
</ng-template>
